export default __webpack_public_path__ + "static/media/006-lantern.81b98167.svg";